// const main = () => import(/* webpackChunkName: "core-vs" */'../components/layouts/vscode/layout-main')

import main from  "../components/layouts/vscode/layout-main.vue"

function setLayout(app, routes) {
    routes.forEach((route, index) => {
        if (index == 0) {
            route.component = main
            return true
        } 
        
        // else {
        //     let path = route.path;
        //     let name = route.name || `gen${index}`;
        //     let component = route.component;
        //     route.path = `/main-${index}`;
        //     route.component = main;
        //     route.redirect = { name: name };
        //     route.children = [{
        //         path,
        //         name,
        //         component
        //     }]
        // }
        // route = {
        //     name: route.name || `gen${index}` + "-parent",
        //     text: route.text,
        //     path: `/main`,
        //     component: main,
        //     redirect: { name: route.name },
        //     icon: route.icon,
        //     hasChildren: false,
        //     children: [route]
        // }

        // routes[index] = route;
    })
}
export default {
    name: "vs",
    maxWidth: 2560,
    minWidth: 1024,
    login: null,
    text: "VSCODE布局",
    desc: "常用于后台管理系统，界面简洁，菜单项较多的场景，内容展示区较大",
    layout: setLayout
}